__turbopack_context__.v({
  "atcErrorRibbon": "ProductListingTemplate-module-scss-module__LxnRKG__atcErrorRibbon",
});
